import { render, staticRenderFns } from "./ClientMailbuilderEmails.vue?vue&type=template&id=555f503a"
import script from "./ClientMailbuilderEmails.vue?vue&type=script&lang=js"
export * from "./ClientMailbuilderEmails.vue?vue&type=script&lang=js"
import style0 from "./ClientMailbuilderEmails.vue?vue&type=style&index=0&id=555f503a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports